import { SignUpStep } from '../common/provider/SignUpContext';

export const stepRouteMapping = {
  [`${SignUpStep[SignUpStep.verifyEmail]}`]: '/',
  [`${SignUpStep[SignUpStep.selectPlan]}`]: '/plan',
  [`${SignUpStep[SignUpStep.orgDetails]}`]: '/create-org',
  [`${SignUpStep[SignUpStep.billingDetails]}`]: '/billing',
  [`${SignUpStep[SignUpStep.taxIndiaDetails]}`]: '/tax',
  [`${SignUpStep[SignUpStep.paymentDetails]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.settingUp]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.paymentComplete]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.setupSuccess]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.setupFailed]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.waitlisted]}`]: '/finalize',
  [`${SignUpStep[SignUpStep.contactAdmin]}`]: '/finalize',
};

export const isCountryIndia = (country: string): boolean => {
  return country === 'IN' || country?.toLowerCase() === 'india';
};

export const composeShortNameFromCompanyName = (companyName: string) => {
  const shortName = companyName.toLowerCase().replace(/[^\w\][^-]/g, '');

  return shortName;
};
